export default __webpack_public_path__ + "static/garage-cleanout-icon-ef66bdd7b353c835a7969e393c62fba2.png";